import { render, staticRenderFns } from "./PMRequestsView.vue?vue&type=template&id=467d6d74&scoped=true"
import script from "./PMRequestsView.vue?vue&type=script&lang=js"
export * from "./PMRequestsView.vue?vue&type=script&lang=js"
import style0 from "./PMRequestsView.vue?vue&type=style&index=0&id=467d6d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d6d74",
  null
  
)

export default component.exports